import DefaultAvatar from "./Images/Avatar/defaultAvatar.png"
import Avatar1 from "./Images/Avatar/Avatar-1.png"
import Avatar2 from "./Images/Avatar/Avatar-2.png"
import Avatar3 from "./Images/Avatar/Avatar-3.png"
import Avatar4 from "./Images/Avatar/Avatar-4.png"
import Avatar5 from "./Images/Avatar/Avatar-5.png"
import Avatar6 from "./Images/Avatar/Avatar-6.png"
import Avatar7 from "./Images/Avatar/Avatar-7.png"
import Avatar8 from "./Images/Avatar/Avatar-8.png"
import Avatar9 from "./Images/Avatar/Avatar-9.png"

import RockPaperScissor from "./Images/Games/RockPaperScissor.jpg";
import MathGenius from "./Images/Games/MathGenius.jpg"
import TicTacToe from "./Images/Games/TicTacToe.jpg"

import Rock from "./Images/Games/RockPaperScissor/Rock.png";
import Paper from "./Images/Games/RockPaperScissor/Paper.png";
import Scissor from "./Images/Games/RockPaperScissor/Scissor.png";


export const avatars = {DefaultAvatar, Avatar1, Avatar2, Avatar3, Avatar4, Avatar5, Avatar6, Avatar7, Avatar8, Avatar9}
export const games = {RockPaperScissor, MathGenius, TicTacToe}
export const RockPaperScissorAsset = {Rock, Paper, Scissor};